import { Field, Formik } from "formik";
import { useCallback } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import * as Yup from "yup";
import Get from "../../api/Get";
import Put from "../../api/Put";
import { APPOINTMENT_UPDATE, CATALOGO_LABORATORIOS_BASE } from "../../api/Routes";
import SimpleLoad from "../../loader/SimpleLoad";

const formatOption = (item) => {
  const label = `${item.code4digits || ""} - ${item.description || ""}`.trim();
  return { value: label, label };
};

function ModalLaboratoriosCatalogo({
  t,
  citaID,
  show,
  setItems,
  setShow,
  auth,
  setShowModalError,
  setErrorServer,
}) {
  const initialValues = { nombre: "", observacionesEspecificas: "" };
  const schemaValidate = Yup.object().shape({
    nombre: Yup.string().required(t("Camporequerido")),
    observacionesEspecificas: Yup.string(),
  });
  const handleClose = () => setShow(false);

  const loadOptions = useCallback(
    (inputValue, callback) => {
      const isDefault = !inputValue || inputValue.trim() === "";
      const common = isDefault ? "true" : "false";
      const searchPart = isDefault ? "%20" : encodeURIComponent(inputValue.trim());
      const url = `${CATALOGO_LABORATORIOS_BASE}/${common}/${searchPart}`;

      Get({ url, access_token: auth.data.access_token })
        .then((resp) => {
          if (resp.data.state && resp.data.data?.response?.content) {
            const options = resp.data.data.response.content.map(formatOption);
            callback(options);
          } else {
            callback([]);
          }
        })
        .catch(() => callback([]));
    },
    [auth.data.access_token]
  );

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="text-dark">{t("laboratorios")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-hidden">
        <Formik
          initialValues={initialValues}
          validationSchema={schemaValidate}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            const observaciones = (values.observacionesEspecificas || "").trim();
            const nombre = observaciones
              ? `${values.nombre} (${observaciones})`
              : values.nombre;
            const data = {
              id: citaID,
              ordenLaboratorios: [{
                nombre,
                observacionesEspecificas: "",
              }],
            };
            Put({
              url: APPOINTMENT_UPDATE,
              data,
              access_token: auth.data.access_token,
              header: true,
            })
              .then((resp) => {
                setSubmitting(false);
                resetForm();
                setItems(resp.data.data.ordenLaboratorios || []);
                handleClose();
              })
              .catch((error) => {
                setSubmitting(false);
                setShowModalError(true);
                if (error.response) setErrorServer(error.response);
              });
          }}
        >
          {({ values, errors, setFieldValue, setFieldTouched, handleSubmit, isSubmitting }) => (
            <Form onSubmit={handleSubmit} className="mt-3">
              {isSubmitting && <SimpleLoad />}
              <Row>
                <Col xs="12" md="12">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">{t("laboratorios")}</Form.Label>
                    <AsyncSelect
                      cacheOptions
                      defaultOptions
                      loadOptions={loadOptions}
                      placeholder={t("Escriba para buscar") || "Escriba para buscar"}
                      value={values.nombre ? { value: values.nombre, label: values.nombre } : null}
                      onChange={(option) => setFieldValue("nombre", option ? option.value : "")}
                      onBlur={() => setFieldTouched("nombre", true)}
                      isClearable
                      loadingMessage={() => t("Cargando opciones...") || "Cargando opciones..."}
                      noOptionsMessage={({ inputValue }) =>
                        inputValue ? t("No hay opciones que mostrar") || "No hay opciones que mostrar" : t("Escriba para buscar") || "Escriba para buscar"
                      }
                    />
                    {errors.nombre && <div className="invalid-feedback d-block">{errors.nombre}</div>}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs="12" md="12">
                  <Form.Group>
                    <Form.Label className="font-weight-bold-600 text-secondary">Observaciones especificas</Form.Label>
                    <Field
                      name="observacionesEspecificas"
                      type="text"
                      className={`form-control input-form ${errors.observacionesEspecificas ? "error" : ""}`}
                    />
                    {errors.observacionesEspecificas && <div className="invalid-feedback d-block">{errors.observacionesEspecificas}</div>}
                  </Form.Group>
                </Col>
              </Row>
              <Row className="grupoBotones">
                <Col className="text-right">
                  <Button variant="outline-success" className="ok-buttom" type="submit">{t("guardar")}</Button>{" "}
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

export default withTranslation()(ModalLaboratoriosCatalogo);
